export function scopesOutsideCatalog(
  value: readonly string[],
  catalog: readonly string[],
): string[] {
  return value.filter((scope) => !catalog.includes(scope))
}

/** Tree checks only cover catalog scopes; keep every held scope outside it. */
export function mergeCheckedScopes(
  value: readonly string[],
  checked: readonly string[],
  catalog: readonly string[],
): string[] {
  return [
    ...scopesOutsideCatalog(value, catalog),
    ...checked.filter((scope) => catalog.includes(scope)),
  ]
}
